import { useState } from "react";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import type { DraftMessageAttachment } from "@/payroll/editor/types";
import { MessageAttachments } from "./message-attachments";

/** Keep pasted text intact. A long request can open without taking over the thread. */
export const OwnerMessage = ({
  children,
  attachments,
}: {
  children: string;
  attachments?: DraftMessageAttachment[];
}) => {
  const [expanded, setExpanded] = useState(false);
  const long = children.length > 1200 || children.split("\n").length > 10;
  return (
    <Stack
      gap={2}
      className="ml-auto max-w-[92%] min-w-0 rounded-2xl bg-neutral px-4 py-3 text-sm text-ink"
    >
      {!!attachments?.length && <MessageAttachments files={attachments} />}
      <p
        className={cn("leading-6 wrap-anywhere whitespace-pre-wrap", {
          "line-clamp-8": long && !expanded,
        })}
      >
        {children}
      </p>
      {long && (
        <Button
          type="button"
          variant="ghost"
          size="xs"
          aria-expanded={expanded}
          className="h-auto self-end px-1 py-0.5 text-subtle"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Show less" : "Show full message"}
        </Button>
      )}
    </Stack>
  );
};
